var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.204 11.27a.804.804 0 00.276-.883.797.797 0 00-.74-.553l-8.385-.17a.793.793 0 01-.735-.515l-2.774-7.997c-.225-.643-1.28-.643-1.504 0l-2.766 7.997h-.001a.792.792 0 01-.734.514l-8.393.171a.802.802 0 00-.465 1.436l6.661 5.074a.797.797 0 01.325.844l-2.442 8.13a.803.803 0 00.293.88c.14.102.303.152.468.152a.805.805 0 00.454-.142l6.93-4.846a.785.785 0 01.883.03l6.89 4.816a.79.79 0 00.921-.01.802.802 0 00.294-.878l-2.447-8.128a.81.81 0 01.327-.845l6.664-5.076z",
    stroke: "#000",
    strokeWidth: 1.167
  })));
}
export default SvgStar;